import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Button, Modal } from 'react-bootstrap'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import './style.scss'
@inject('store')
@observer
export default class MsgModalComponent extends Component {
  render() {
    const { msgModalTitle, msgModalBody, showMsgModal, nextButton } = this.props

    return (
      <Modal
        show={showMsgModal}
        onHide={() => nextButton()}
        className="msg-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{msgModalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ok-sign"></div>
          <p className="text text--14">{msgModalBody}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-green height h-36 width w-100"
            onClick={nextButton}
          >
            {getStringByTextKey('common.okBtn')}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Console/Modal/MsgModal/index.js